<div class="form-group" [class.has-error]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id">
      {{ props.label }}
      @if (props.required && props.hideRequiredMarker !== true) {
        <span>*</span>
      }
    </label>
  }
  <ng-template #fieldComponent></ng-template>
  @if (showError) {
    <div class="invalid-feedback" [style.display]="'block'">
      <formly-validation-message [style.display]="'none'" #validationRef [field]="field"></formly-validation-message>
      <!-- FD CHECK: <ng-container *ngIf="validationRef && validationRef.errorMessage"></ng-container> -->
      @if (validationRef && validationRef.errorMessage) {
        {{ validationRef.errorMessage }}
      }
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
